import React from 'react';
import { Link, useForm } from '@inertiajs/react';
import { Alert } from '../../components/Alert';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import ValidationError from '../../components/ValidationError';
import { useTrans } from '../../hooks/useTrans';
import AuthPanel from '../../components/layout/auth/AuthPanel';

export default function ForgotPassword({ flash }) {
    const translate = useTrans();

    const { data, setData, post, processing, errors } = useForm({
        email: '',
    });

    function handleSubmit(e) {
        e.preventDefault();
        post('/forgotpassword');
    }

    return (
        <>
            <AuthPanel>
                <h5 className="text-lg font-bold text-[#003545]">
                    {translate('Wachtwoord vergeten')}
                </h5>
                <hr className="my-4 border-[#dfdfdf]" />

                <p className="text-sm text-[#003545] mb-2">
                    {translate('Vul hieronder je e-mailadres in en we sturen je een link om je wachtwoord opnieuw in te stellen.')}
                </p>
                <p className="text-sm text-[#003545] mb-2">
                    {translate('Indien je geen e-mailadres hebt gekoppeld aan je account, kun je contact opnemen met onze afdeling Customer Service via:')}
                </p>
                <a href="mailto:cs@schotpoort.nl" className="inline-flex items-center gap-1 font-bold text-sm text-[#003545] no-underline mb-2">
                    <svg className="w-4 h-4 fill-[#ffd500]" viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
                    cs@schotpoort.nl
                </a>

                <hr className="my-4 border-[#dfdfdf]" />

                {flash && (
                    <Alert variant={flash.type}>{flash.description}</Alert>
                )}

                <form onSubmit={handleSubmit} autoComplete="off">
                    <div className="space-y-4">
                        <div>
                            <label className="block text-sm font-bold text-[#003545] mb-1">
                                {translate('E-mailadres')}
                            </label>
                            <Input
                                type="email"
                                value={data.email}
                                onChange={(e) => setData('email', e.target.value)}
                                required
                                autoFocus
                                className="h-[44px] font-normal"
                            />
                            <ValidationError message={errors.email} />
                        </div>

                        <Button variant="primary" type="submit" disabled={processing} className="w-full">
                            {translate('Versturen')}
                        </Button>
                    </div>
                </form>
            </AuthPanel>

            <Link href="/login" className="mt-4 block text-center text-sm text-white/60 no-underline hover:text-white">
                {translate('Annuleren')}
            </Link>
        </>
    );
}
